
// import React from 'react';
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// // import '../css/CustomSlider.css';
// // import { FaInfoCircle } from 'react-icons/fa'; 
// const CustomSlider = ({ items }) => {
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     pauseOnHover: true,
//   };

//   return (
//     <div className="slider-container">
//       <Slider {...settings}>
//         {items.map((item, index) => (
//           <div key={index} className="slider-item text-center">
//                         <div className="icon-container">
//                         {/* <span className="material-icons slider-icon">“</span> Icon positioned in the corner */}
//             </div>
//             <p className="slider-heading">{item}</p>
            

//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default CustomSlider;


import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../css/CustomSlider.css";

const CustomSlider = ({ items }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    arrows: false,
  };

  return (
    <div className="custom-slider-container">
      <Slider {...settings}>
        {items.map((item, index) => (
          <div key={index} className="custom-slide">
            <div className="slide-content">
              {/* <img src={logo} alt="Woodland Escape Resort" className="slide-logo" /> */}
              <p className="slide-text">“{item}”</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CustomSlider;
